// src/services/chatService.js
import axios from 'axios';
import { env } from 'configs/EnvironmentConfig';

const getChatMicroserviceBaseUrl = () =>
  env?.IFRAME_CHAT_URL || env?.BASE_URL || 'https://chat-microservice.voiceracx.ai';

const normalizeChatResponse = (data) => {
  const completion =
    data?.completion ??
    data?.message ??
    data?.answer ??
    null;

  return {
    ...data,
    completion,
  };
};

const buildChatPayload = ({ chat_agent_id, chat_id, user_id, message, files }) => {
  const formData = new FormData();
  formData.append('chat_agent_id', chat_agent_id);
  formData.append('chat_id', chat_id);
  formData.append('user_id', String(user_id));
  formData.append('message', message || '');
  if (files?.length) {
    files.forEach((file) => formData.append('files', file));
  }
  return formData;
};

const postChatMessage = async (path, payload) => {
  const apiBaseUrl = getChatMicroserviceBaseUrl();
  const url = `${apiBaseUrl}${path}`;
  const { data } = await axios.post(url, payload);
  return normalizeChatResponse(data);
};

/**
 * In-app "Chat with Agent" panel — chat microservice `/chatagent/chat`.
 */
export const sendUiChatMessageToAgent = async ({ chat_agent_id, message, chat_id, user_id, files }) => {
  return postChatMessage('/chatagent/chat', buildChatPayload({ chat_agent_id, chat_id, user_id, message, files }));
};

/**
 * Embed / iframe widget — chat microservice `/chatagent/iframechat`.
 *
 * Returns full response `data` (e.g. `is_connected_to_flex`) plus a `completion` field.
 */
export const sendMessageToAgent = async ({ chat_agent_id, message, chat_id, user_id, files }) => {
  return postChatMessage('/chatagent/iframechat', buildChatPayload({ chat_agent_id, chat_id, user_id, message, files }));
};
